import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IOrganisationImage } from '../../../../app/interfaces/organisation-image';
import { OrganisationImageApiService } from './organisation-image-api-service';

// @Injectable()
export class OrganisationImageDataSource extends DataSource<any> {
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private OrganisationImage: BehaviorSubject<IOrganisationImage[]> =
    new BehaviorSubject([]);

  constructor(
    protected role: string,
    protected organisationId: number,
    protected OrganisationImageApi: OrganisationImageApiService
  ) {
    super();
  }

  public load() {
    this.loading.next(true);

    this.OrganisationImageApi.list(this.role, this.organisationId).then(
      (data: IOrganisationImage[]) => {
        this.OrganisationImage.next(data);
        this.loading.next(false);
      },
      (error) => this.loading.next(false)
    );
  }

  public save(items: IOrganisationImage[] = []) {
    return Promise.all(
      items.map((item) =>
        this.OrganisationImageApi.save(this.role, this.organisationId, item)
      )
    ).then(() => {
      return this.load();
    });
  }

  /**
   * Connects a collection viewer (such as a data-table) to this data source.
   * @param collectionViewer The component that exposes a view over the data provided by this
   *     data source.
   * @returns Observable that emits a new value when the data changes.
   */
  public connect(collectionViewer?: CollectionViewer) {
    return this.OrganisationImage;
  }

  /**
   * Disconnects a collection viewer (such as a data-table) from this data source. Can be used
   * to perform any clean-up or tear-down operations when a view is being destroyed.
   *
   * @param collectionViewer The component that exposes a view over the data provided by this
   *     data source.
   */
  public disconnect(collectionViewer: CollectionViewer) {}
}
